import { Institution } from "../../../../models/data/blobby/institution.data";
import { InstitutionStoreModel } from "../../../../models/store/institution.store.model";

type InstitutionModel1 = Omit<InstitutionModel2, "v" | "sq_lg_url" | "fl_lg_url"> & {
  v: 1;
};

type InstitutionModel2 = Omit<InstitutionModel3, "v" | "org" | "lnkT"> & {
  v: 2;
};

type InstitutionModel3 = Omit<InstitutionStoreModel, "v" | "fskId"> & {
  v: 3;
};

export const institution_v0_to_v1 = (institution: Institution): InstitutionModel1 => {
  return {
    v: 1,
    vid: "",
    id: institution.id,
    dc: new Date().toDateString(),
    dm: new Date().toDateString(),
    fk: institution.basiqId,
    name: institution.name,
    swt: {
      bac: institution.swift.bankCode,
      cc: institution.swift.countryCode,
      brc: institution.swift.branchCode,
      lc: institution.swift.locationCode,
    },
    avaAcc: institution?.availableAccounts?.map((account) => {
      return {
        id: account?.id,
        /** **name** **/
        nm: account?.name,
        /** **institutionName** **/
        istNm: account?.institutionName,
        /** **interestRates** **/
        intRts: account?.interestRates?.map((rates) => {
          return {
            rn: rates?.range,
            /** **banded** **/
            ba: rates?.banded,
            /** **rate** **/
            ra: rates?.rate,
            /** **symbol** **/
            sy: rates?.symbol,
            /** **last_updated** **/
            lu: rates?.last_updated,
            /** **condition_intrinsic_desc** **/
            cid: rates?.condition_intrinsic_desc,
            /** **condition_action_desc** **/
            cad: rates?.condition_action_desc,
          };
        }),
        /** **useForScenarioBestRate** **/
        ufsbr: account?.useForScenarioBestRate,
        /** **link** **/
        lk: account?.link,
      };
    }),
    bic: {
      bc: institution?.bic?.bankCode,
      cc: institution?.bic?.countryCode,
      lc: institution?.bic?.locationCode,
    },
  };
};

export const institution_v1_to_v2 = (institution: InstitutionModel1): InstitutionModel2 => {
  return {
    ...institution,
    fl_lg_url: "",
    sq_lg_url: "",
    v: 2,
  };
};

export const institution_v2_to_v3 = (institution: InstitutionModel2): InstitutionModel3 => {
  return {
    ...institution,
    org: "auto",
    lnkT: null,
    v: 3,
  };
};

export const institution_v3_to_v4 = (institution: InstitutionModel3): InstitutionStoreModel => {
  return {
    ...institution,
    fskId: null,
    v: 4,
  };
};
